module.exports = __webpack_public_path__ + "static/media/notifications_menu_blue.867ecf35.svg";